import {EncryptType} from './EncryptType.enum';

export function getPassphrase(encryptKey: string, type?: EncryptType) {
  // KP{type}S{encryptKey} == KakaoPage {type} Salt {encryptKey}
  return type ? `KP${type}S${encryptKey}` : encryptKey;
}
